import React from "react";
import { EmbeddedReportPage } from "components";

// Компонент дашборд Prom
const AnalysisPromPage = () => {
  return (
    <EmbeddedReportPage
      pageTitle="Аналітика Prom"
      iframeTitle="Звіт по Prom"
      endpointUrl="/reports/analysis-prom/embed-url"
    />
  );
};

export default AnalysisPromPage;
